export const CREATE_FORM_TABLE_ROW_EVENT_NAME = 'createFormTableRow' as const;

export interface CreateFormTableRowEventData {
  tableName: string;
}

export const emitCreateFormTableRow = (tableName: string) => {
  document.dispatchEvent(
    new CustomEvent(CREATE_FORM_TABLE_ROW_EVENT_NAME, { detail: { tableName } })
  );
};

export const listenCreateFormTableRow = (
  listener: (
    this: Document,
    event: DocumentEventMap[typeof CREATE_FORM_TABLE_ROW_EVENT_NAME]
  ) => any
) => {
  document.addEventListener(CREATE_FORM_TABLE_ROW_EVENT_NAME, listener);
  return () =>
    document.removeEventListener(CREATE_FORM_TABLE_ROW_EVENT_NAME, listener);
};
